import getConfig from 'next/config';

import base from './base';

const { publicRuntimeConfig: { assetPrefix } } = getConfig();

const TRADINGVIEW_STYLE = {
  bg: '#FBFBFB',
  crosshair: '#888888',
  short: '#ea0070',
  shortFill: '#ea0070',
  long: '#70a800',
  longFill: '#70a800',
  cta: '#FBFBFB',
  ctaHighlight: '#F5F5F5',
  alert: '#FFD506',
  category: 'light',
  grid: '#E6E6E6',
  lineColor: '#555',
  textColor: '#999',
  maLine: '#f0b90b',
  ma1: '#ffc200',
  ma2: '#6600cc',
  ma3: '#cc0066',
};

const tradingViewStyle = TRADINGVIEW_STYLE;

export default {
  ...base,
  mode: 'LIGHT',
  fiatPriceColor: '#333333',
  bg: '#fff',
  loginBg: '#fafafa',
  greyBg: '#f7f7f7',
  border: '#e6e6e6',
  border1: '#d4d4d4',
  activeBorder: '#f3ba2f',
  boxShadow: '0 6px 12px rgba(0,0,0,.175)',
  toolTipBoxShadow: '0 0 12px rgba(0,0,0,.175)',
  activeBg: '#fff9e7',
  dropdownBg: '#fff',
  boxheadbg: '#f7f7f7',
  tableRowBg: '#fafafa',
  tabBorderColor: '#ddd',
  tabBg: '#fff',
  buttonbg: '#fff',
  chartbuttonbg: '#e6e6e6',
  buttonbgactive: '#f0b90b',
  buttonbgdisabled: '#ddd',
  buttonColorActive: '#f0b90b',
  okButtonBg: '#f0b90b',
  cancelButtonBg: '#fff',
  up: '#70a800',
  down: '#ea0070',
  shallowDigitOpacity: 0.45,
  highlight: '#f0b90b',
  chartTheme: 'chart-white2',
  depthTheme: 'depth-white',
  chartDropdownSeparator: '#f4f4f4',
  fontColor: '#333',
  fontColor1: '#666',
  fontColor2: '#999',
  fontColor3: '#ccc',
  fontColor4: '#fff',
  fontColor5: '#333',
  formsbg: '#f7f7f7',
  inputBorder: '#e2e2e2',
  formsHeaderbg: 'transparent',
  inputBg: '#fff',
  heading: '#262d33',
  tableRowHoverBg: 'rgba(253,247,236,1)',
  miniSymbolsTabActive: 'rgba(253, 242, 216, 0.75)',
  loadingShadeColor: 'rgba(255,255,255,0.3)',
  errorInputBg: '#f7dee0',
  errorInputBorderColor: '#ef4b5a',
  tooltipBg: '#fff',
  counterColor: '#f5bc00',
  bnbBurning: '#e8b342',
  bnbBurnClose: '#aaa',
  buttonPrimaryColor: '#F0B90B',
  xfersLogoBoxBg: '#23448E',
  lineColor: '#f0f0f0',
  sectionBorderRadius: '4px',
  sectionBoxShadow: '-4px 4px 10px 0px rgba(0,0,0,0.1)',
  // web 2.0 login
  checkBoxBorder: '#848E9C',
  descriptionWord: '#48515D',


  tradingViewStyle,
  tradingViewCssPath: `${assetPrefix}/static/tradingview/themes/tv-light-theme-v1.min.css`,


  tradingViewOverrides: {
    'volumePaneSize': 'medium',
    'paneProperties.background': tradingViewStyle.bg,
    'symbolWatermarkProperties.transparency': 85,
    'scalesProperties.backgroundColor': '#151a1e',
    'scalesProperties.textColor': '#555',

    'paneProperties.vertGridProperties.color': tradingViewStyle.grid,
    'paneProperties.horzGridProperties.color': tradingViewStyle.grid,
    'paneProperties.crossHairProperties.color': tradingViewStyle.crosshair,
    'scalesProperties.lineColor': tradingViewStyle.lineColor,
    'symbolWatermarkProperties.color': 'rgba(0, 0, 0, 0)',

    'mainSeriesProperties.style': 1,

    //  Candles styles
    'mainSeriesProperties.candleStyle.upColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.downColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.drawWick': true,
    'mainSeriesProperties.candleStyle.drawBorder': true,
    'mainSeriesProperties.candleStyle.borderColor': '#C400CB',
    'mainSeriesProperties.candleStyle.borderUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.borderDownColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.wickUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.wickDownColor': tradingViewStyle.short,

    'study_Overlay@tv-basicstudies.barStyle.upColor': 'blue',
    'study_Overlay@tv-basicstudies.barStyle.downColor': 'blue',

    'study_Overlay@tv-basicstudies.lineStyle.color': 'blue',

    'study_Overlay@tv-basicstudies.areaStyle.color1': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.color2': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.linecolor': 'blue',

  },
  emergencyNotice: {
    wrapBg: '#212121',
    boxBg: '#3d3d3d',
    dotColor: '#f0b90b',
    titleColor: '#fff',
    detailLinkColor: '#f0b90b',
  },
  FormRow: {
    MaxQuantityBoxBg: '#f3ba2e',
    MaxQuantityBoxColor: '#333',
    FiatPriceBoxBg: 'rgba(38, 38, 38, 1)',
    FiatPriceBoxColor: '#fff',
  },
  Download: {
    bg: '#fff',
  },
  miniSymbolsFiatPrice: {
    bg: 'rgba(38, 38, 38, 1)',
    color: '#fff',
    shadowColor: 'rgba(51,51,51,0.3)',
    linkHoverColor: '#e8b342',
  },
  orderBookTotalBoxBg: '#262626',
  balanceTooltipBg: '#fff',
};
